interface InfoBoxOptions {
    url: string;
    uid: string;
}

export default class InfoBox {
    public static init(options: InfoBoxOptions): void {
        $(() => {
            const url: string = options.url;

            const wx = $(window).width();
            let mins = 0;

            const def = {
                wx: wx,
                wy: $(window).height(),
                mobile: wx < 700 ? 1 : 0,
                uid: options.uid,
            };

            function queryBox(action, params?, success?) {
                var posts = $.extend({}, def, params);
                posts['action'] = action;

                $.post(url, posts, function (r) {
                    if (r.success) {
                        var skip = false;

                        if (r.onetime) {
                            var key = 'infobox.' + r.id;

                            if (sessionStorage.getItem(key) == '1') {
                                skip = true;
                            } else {
                                sessionStorage.setItem(key, '1');
                            }
                        }

                        if (!skip) {
                            (<any> $).fancybox({
                                content: r.content,
                                animation: 'none'
                            });
                        }

                        if (success != null) {
                            success();
                        }
                    }
                });
            }

            var topleave = false;

            $(document).mouseleave(function (e) {
                if (!topleave && e.clientY < 100) {
                    queryBox('leave-top', {
                        mins: mins
                    }, function () {
                        topleave = true;
                    });
                }
            });

            window.setInterval(function () {
                mins++;

                queryBox('timer', {
                    mins: mins
                });
            }, 60 * 1000);

            queryBox('init');
        });
    }
}
